module.exports = __webpack_public_path__ + "img/WMS_bg1_1.d25afa24.jpg";